<template>
  <Modal
    id="modal_confirmation_suppr_etab"
    element-to-focus=".confirm"
    modal-class="modal-custom"
    @hide="!$event && hide()"
  >
    <template #title>
      {{ $t("header.suppression-etab-actuel") }}
    </template>
    <template #content>
      <ModalTab>
        <template #titre>
          {{ $t("general.attention") }}
        </template>

        <template #content>
          <h4>
            {{ $t("header.suppression-etab-actuel-message-confirmation") }}
          </h4>
        </template>
      </ModalTab>
    </template>
    <template #footer>
      <ButtonClassic
        variant="solid"
        color="primary"
        class="confirm"
        @click="confirm()"
      >
        {{ $t("general.oui") }}
      </ButtonClassic>
      <ButtonClassic
        variant="solid"
        color="secondary"
        @click="hide()"
      >
        {{ $t("general.non") }}
      </ButtonClassic>
    </template>
  </Modal>
</template>

<script>
import { ButtonClassic, Modal } from "@lde/core_lde_vue";

import ModalTab from "@/components/modals/Tab.vue";

export default {
    name: "ModalConfirmationSupprEtab",
    components: {
        ButtonClassic,
        Modal,
        ModalTab,
    },
    emits: ["confirm"],
    methods: {
      confirm() {
        this.$emit("confirm");
        this.hide();
      },
        hide() {
            this.$modal.hide("modal_confirmation_suppr_etab");
        },
    },
}
</script>

<style lang="scss">
@use "@/assets/styles/components/modals/modal_custom.scss";
</style>